module.exports = __webpack_public_path__ + "img/navBar.f958e674.png";